import { useState } from 'react'
import { useStore, selectActiveClip } from '../store'
import { FORMATS } from '../lib/formats'
import { detectFaceFocus } from '../lib/reframe'
import type { ReframeMode } from '../types'

const REFRAME_MODES: { key: ReframeMode; label: string; hint: string }[] = [
  { key: 'center', label: 'Giữa', hint: 'Cắt ở giữa khung' },
  { key: 'face', label: 'Khuôn mặt', hint: 'Tự dò mặt để canh (khi xuất)' },
  { key: 'manual', label: 'Thủ công', hint: 'Kéo điểm 🎯 trên video' },
]

/** Bảng chọn tỉ lệ xuất đa nền tảng + chế độ reframe (Giai đoạn 4). */
export function FormatPanel() {
  const exportFormats = useStore((s) => s.exportFormats)
  const reframe = useStore((s) => s.reframe)
  const busy = useStore((s) => s.busy)
  const clip = useStore(selectActiveClip)
  const toggleFormat = useStore((s) => s.toggleFormat)
  const setReframeMode = useStore((s) => s.setReframeMode)
  const setFocus = useStore((s) => s.setFocus)
  const setStatus = useStore((s) => s.setStatus)

  const [detecting, setDetecting] = useState(false)
  const hasCrop = exportFormats.some((k) => k !== 'original')

  const onDetect = async () => {
    if (!clip || detecting) return
    setDetecting(true)
    setStatus('Đang dò khuôn mặt…')
    const focus = await detectFaceFocus(clip)
    if (focus) {
      setFocus(focus.fx, focus.fy)
      setStatus(`✅ Đã canh theo khuôn mặt (${Math.round(focus.fx * 100)}%, ${Math.round(focus.fy * 100)}%).`)
    } else {
      setStatus('Không dò được khuôn mặt (trình duyệt không hỗ trợ FaceDetector). Hãy chỉnh Thủ công.')
    }
    setDetecting(false)
  }

  return (
    <div className="logopanel">
      <div className="logopanel-head">📐 Xuất đa nền tảng</div>

      <div className="fmt-list">
        {FORMATS.map((f) => {
          const on = exportFormats.includes(f.key)
          return (
            <button
              key={f.key}
              className={`fmt-chip ${on ? 'on' : ''}`}
              disabled={busy}
              onClick={() => toggleFormat(f.key)}
              title={f.label}
            >
              <span className="fmt-check">{on ? '☑' : '☐'}</span> {f.short}
            </button>
          )
        })}
      </div>
      <div className="muted small-note">Chọn tất cả tỉ lệ muốn xuất — bấm “Xuất” tạo lần lượt từng file.</div>

      {hasCrop && (
        <div className="reframe">
          <label>Reframe (khi đổi tỉ lệ)</label>
          <div className="seg">
            {REFRAME_MODES.map((m) => (
              <button
                key={m.key}
                className={`seg-btn ${reframe.mode === m.key ? 'active' : ''}`}
                disabled={busy}
                onClick={() => setReframeMode(m.key)}
                title={m.hint}
              >
                {m.label}
              </button>
            ))}
          </div>

          {reframe.mode === 'face' && (
            <button className="btn small" disabled={busy || detecting || !clip} onClick={onDetect}>
              {detecting ? 'Đang dò…' : '🙂 Dò khuôn mặt ngay'}
            </button>
          )}
          {reframe.mode === 'manual' && (
            <div className="muted small-note">
              Kéo điểm 🎯 trên video để chọn phần muốn giữ. Khung xanh = vùng sẽ xuất.
            </div>
          )}
        </div>
      )}
    </div>
  )
}
